var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.USER,
      "field": _vm.partnerId
    }
  }, [_vm._l(_vm.first, function (tag, index) {
    return _c('tag-chip', {
      key: 'tag' + tag ? tag.id : index,
      attrs: {
        "value": tag,
        "size": _vm.size
      }
    });
  }), _vm.remaining.length ? _c('tooltip', {
    attrs: {
      "text": _vm.remaining.map(function (tag) {
        return tag.titleReadable;
      }).join('<br/>')
    }
  }, [_c('v-chip', {
    staticClass: "ml-1 pa-1",
    attrs: {
      "color": "grey",
      "x-small": 'x-small' === _vm.size,
      "small": 'small' === _vm.size,
      "large": 'large' === _vm.size,
      "x-large": 'x-large' === _vm.size,
      "outlined": ""
    }
  }, [_vm._v(" +" + _vm._s(_vm.remaining.length) + " ")])], 1) : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }